import React, { useEffect, useRef } from 'react';

const CursorGlow = () => {
	const glowRef = useRef(null);

	useEffect(() => {
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		if (prefersReducedMotion) return;

		const handleMouseMove = e => {
			if (glowRef.current) {
				glowRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
			}
		};
		window.addEventListener('mousemove', handleMouseMove);
		return () => window.removeEventListener('mousemove', handleMouseMove);
	}, []);

	return (
		<div
			ref={glowRef}
			className="hidden md:block fixed top-0 left-0 w-72 h-72 -ml-36 -mt-36 rounded-full pointer-events-none z-[5]"
			style={{
				background:
					'radial-gradient(circle, rgba(255,106,26,0.12) 0%, rgba(201,164,74,0.06) 45%, transparent 70%)',
				willChange: 'transform',
			}}
			aria-hidden="true"
		/>
	);
};

export default CursorGlow;
